import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import useDefaultChartsContainer from 'hooks/defaultChartsContainer';
import { Container } from './styles';
import WordCloudChart from './WordCloudChart';
import { useAuth } from 'hooks/auth';

const WordCloudTermContainer: React.FC = () => {
  const intl = useIntl();
  const { isUserLogged } = useAuth();
  
  const services = useMemo(() => {
    if (!isUserLogged) return ['facebook', 'instagram', 'misc'];
    return ['facebook', 'instagram', 'twitter', 'misc'];
  }, [isUserLogged]);

  const { paramsDatas, loading, searchedTerms } = useDefaultChartsContainer(
    '/historical_volume.json',
    {
      service: services,
      grouping: 'term',
      max_volume_size: 20,
    },
  );

  interface Word {
    text: string;
    value: number;
  }

  const words: Word[] = useMemo(() => {
    return (
      paramsDatas?.values?.().next().value?.map((item: any) => ({
        text: item.label,
        value: item.value,
      })) || []
    );
  }, [paramsDatas]);

  return (
    <Container>
      <WordCloudChart
        data={words}
      />
    </Container>
  );
};

export default WordCloudTermContainer;